import { render } from "./FooterHomePrincipal.vue?vue&type=template&id=4f1b6cf0"
import script from "./FooterHomePrincipal.vue?vue&type=script&lang=js"
export * from "./FooterHomePrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__